import React from "react";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import DiscoverApi from "../../../api/DiscoverApi";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import Constants from "../../../configurations/constants";
import CaseRequestFilter from "./CaseRequestFilter";
import CaseRequestsTable from "./CaseRequestsTable";
import CaseRequestModal from "./CaseRequestModal";
import { DiscoverConstants } from "../../../configurations/discoverConfigs/discoverConstants";

class CaseRequestPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tableData: [],
      selectedRequest: null,
      loading: false,
      pageNum: 0,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pages: 0,
      filterParams: null
    };
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onRequestRowClick = this.onRequestRowClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.getCaseRequest = this.getCaseRequest.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  componentDidMount() {
    //Load data on mount
    this.onSearchHandler({
      status: DiscoverConstants.CaseRequestStatus.Declined,
      pageSize: this.state.pageSize
    });
  }

  onSearchHandler(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true, tableData: [] };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    DiscoverApi.getCasesRequest(params)
      .then(response => {
        let data = response.data && response.data.content;
        data = data.map(d => {
          return {
            ...d,
            lastAttemptOn: Util.toUserLocalTime(d.lastAttemptOn),
            createdOn: Util.toUserLocalTime(d.createdOn),
            lastUpdatedOn: Util.toUserLocalTime(d.lastUpdatedOn)
          };
        });
        let totalCount = response.data && response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Discover Requests");

        this.setState({
          tableData: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_CASE_REQUESTS}`
        ]);
        this.setState({ loading: false });
      });
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.onSearchHandler(params);
    }
  }

  getCaseRequest(caseNumber) {
    this.setState({ loading: true });
    DiscoverApi.getDiscoverCase(caseNumber)
      .then(response => {
        let data = response.data;
        data = {
          ...data,
          createdOn: Util.toUserLocalTime(data.createdOn),
          lastUpdatedOn: Util.toUserLocalTime(data.lastUpdatedOn)
        };
        this.setState({ selectedRequest: data, loading: false });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_CASES}`
        ]);
        this.setState({ loading: false });
      });
  }

  onRequestRowClick(index) {
    this.setState({ loading: true });
    const selectedRequest = this.state.tableData[index];
    this.setState({ selectedRequest, loading: false });
    //this.getCaseRequest(selectedRequest.caseNumber);
  }

  handleCloseModal(reloadDataFlag) {
    this.setState({ selectedRequest: null });
    if (reloadDataFlag) {
      this.onSearchHandler(this.state.filterParams);
    }
  }

  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Discover Case Requests" />
        <CaseRequestFilter onSearchHandler={this.onSearchHandler} />
        <Divider />
        <CaseRequestsTable
          onRowClick={this.onRequestRowClick}
          tableData={this.state.tableData}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          paginatedCallBack={this.paginateid}
        />
        {this.state.selectedRequest && (
          <CaseRequestModal
            onRequestClose={this.handleCloseModal}
            getCaseRequest={this.getCaseRequest}
            isOpen={this.state.selectedRequest != null}
            caseRequest={this.state.selectedRequest}
          />
        )}
      </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(CaseRequestPage, [Permissions.CREATE_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/discover/caseRequests/CaseRequestPage.js